/** Grouped, colored language selector for all AllBaise transcription hubs. */
import * as React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANG_GROUPS, LANG_FLAGS, LANG_NAMES } from "@/config/languages";

const GROUP_ORDER = ["Global", "African", "Mzansi"];

const GROUP_COLORS = {
  Global: { text: "text-blue-600", bg: "bg-blue-100" },
  African: { text: "text-amber-600", bg: "bg-amber-100" },
  Mzansi: { text: "text-green-600", bg: "bg-green-100" },
};

export default function LanguageSelect({ value, onChange, includeAuto = true, exclude, placeholder = "Select language" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="bg-slate-50 border-slate-300 rounded-none min-w-[180px]">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-white border-slate-300 rounded-none max-h-72">
        {includeAuto && <SelectItem value="auto">🌐 Auto-detect</SelectItem>}
        {GROUP_ORDER.map((group) => {
          const codes = LANG_GROUPS[group];
          if (!codes) return null;
          const filtered = exclude ? codes.filter((c) => c !== exclude) : codes;
          if (filtered.length === 0) return null;
          const colors = GROUP_COLORS[group] || { text: "text-gray-500", bg: "bg-gray-100" };
          return (
            <div key={group}>
              <div className={`px-2 py-1 text-[10px] uppercase font-bold tracking-wider ${colors.text}`}>
                <span className={`inline-block px-1.5 py-0.5 rounded ${colors.bg}`}>{group}</span>
              </div>
              {filtered.map((code) => (
                <SelectItem key={code} value={code} className="text-sm">
                  {LANG_FLAGS[code] || "🌐"} {LANG_NAMES[code] || code}
                </SelectItem>
              ))}
            </div>
          );
        })}
      </SelectContent>
    </Select>
  );
}
